module.exports = __webpack_public_path__ + "img/sponsor.9c365e31.jpg";